import * as React from 'react';
import { ThunkDispatch } from 'redux-thunk';
import i18next from 'i18next';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import { AppState } from '../../../store';
import { UserContainer, BackgroundImage, UserForm, Form, Title, SubTitle, FormFields } from '../../../styles/styled-components/User/User';
import { Authentication, LoginFormPayload, SendOTPFormPayload } from '../../../models/authentication';
import { HTTPStatusCode, Type } from '../../../helpers/types';
import { FormField } from '../../../components/FormField/FormField';
import { SubmitButton } from '../../../components/SubmitButton/SubmitButton';
import { RouteComponentProps } from 'react-router';
import { getCurrentAppLang } from '../../../helpers/util';
import { actionSendOTP } from '../../../store/authentication/action';
import FormError from '../../../components/FormError/FormError';

interface ForgotPasswordProps extends RouteComponentProps<any> {
  sendOTP: (payload: SendOTPFormPayload) => void;
  authentication: Authentication;
}
export interface LoginProps {
  login: (payload: LoginFormPayload) => void;
  authentication: Authentication;
}
interface LoginViewStates {
  username: string;
  loader: boolean;
  error?: string;
}

class ForgotPassword extends React.Component<ForgotPasswordProps, LoginViewStates> {

  state = {
    username: '',
    loader: false,
  };

  async handleSubmit(values: LoginViewStates, actions: any): Promise<void> {
    this.setState({ loader: true });
    const language = getCurrentAppLang(true).split('_')[1];
    await this.props.sendOTP({ username: values.username, type: Type.EMAIL, lang: language });
    if (this.props.authentication.error && this.props.authentication.error.status) {
      const status = this.props.authentication.error.status;
      let errMsg = 'form.generic.error';
      if (status === HTTPStatusCode.TooManyRequest) {
        errMsg = 'verification.error.max';
      }
      actions.setStatus({ error: errMsg });
      this.setState({ loader: false });
    } else {
      this.props.history.push(`verification?username=${encodeURIComponent(values.username)}&type=forgot-password`);
    }
  }

  render() {
    const validationSchema = Yup.object().shape({
      username: Yup.string().email('form.email.error.invalidFormat').required('form.email.error.empty'),
    });

    return (
      <UserContainer>
        <BackgroundImage />
        <UserForm>
          <Formik initialValues={this.state}
            onSubmit={(values, actions) => this.handleSubmit(values, actions)}
            validationSchema={validationSchema} >
            {({ status }) => (
              <Form method="POST">

                <Title>{i18next.t('resetPassword.title')}</Title>
                <SubTitle>{i18next.t('resetPassword.text')}</SubTitle>
                <FormError name="ResetPassword" data={status} />

                <FormFields>

                  <FormField name="username" label={i18next.t('form.email.label')} >
                    <Field name="username" className="input" maxLength={200} placeholder={i18next.t('form.email.placeholder')} />
                  </FormField>

                  <SubmitButton loader={this.state.loader} >
                    {i18next.t('resetPassword.continueButton')}
                  </SubmitButton>

                </FormFields>
              </Form>
            )}
          </Formik>
        </UserForm>

      </UserContainer>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    authentication: state.authentication,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<undefined, undefined, AnyAction>) => {
  return {
    sendOTP: (payload: SendOTPFormPayload) => dispatch(actionSendOTP(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);